<students>
    <div class="modal {state.dialog.open ? 'active' : ''}"
         role="dialog"
         aria-modal="true"
         aria-hidden={!state.dialog.open}
         aria-labelledby="students-dialog-title">
        <a class="modal-overlay" href="#close" role="button" aria-label="Tutup dialog" onclick={closeDialog}></a>
        <div class="modal-container">
            <div class="modal-header">
                <button class="btn btn-clear float-right" aria-label="Tutup" disabled={state.dialog.saving} onclick={closeDialog}></button>
                <div class="modal-title h5" id="students-dialog-title">{dialogTitle()}</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <p>{dialogDescription()}</p>
                    <div if={state.dialog.needsReason}>
                        <div class="form-group">
                            <label class="form-label" for="students-dialog-reason">Alasan</label>
                            <input id="students-dialog-reason" class="form-input" placeholder="Alasan penonaktifan" value={state.dialog.reason} oninput={event => update({dialog: {...state.dialog, reason: event.target.value}})}>
                        </div>
                    </div>
                    <div if={state.dialog.kind === 'transfer'}>
                        <div class="form-group">
                            <label class="form-label">Dari</label>
                            <input class="form-input" disabled value="{sourceYearLabel()} → {state.filters.classLabel}">
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="students-dialog-dest-year">Ke tahun akademik</label>
                            <select id="students-dialog-dest-year" class="form-select" value={state.dialog.destYear} onchange={event => update({dialog: {...state.dialog, destYear: event.target.value}})}>
                                <option value="">Pilih tahun akademik</option>
                                <option each={year in state.years} value={year.ID}>{year.label}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="students-dialog-dest-class">Ke kelas</label>
                            <select id="students-dialog-dest-class" class="form-select" value={state.dialog.destClass} onchange={event => update({dialog: {...state.dialog, destClass: event.target.value}})}>
                                <option value="">Pilih kelas</option>
                                <option each={item in state.classes} value={item.label}>{item.label}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn" disabled={state.dialog.saving} onclick={closeDialog}>Batal</button>
                <button id="students-dialog-confirm"
                        class="btn {dialogConfirmClass()} loading-{state.dialog.saving}"
                        disabled={state.dialog.saving || !dialogConfirmEnabled()}
                        onclick={confirmDialog}>{dialogConfirmLabel()}</button>
            </div>
        </div>
    </div>

    <div class="modal modal-lg {state.importModal.open ? 'active' : ''}"
         role="dialog"
         aria-modal="true"
         aria-hidden={!state.importModal.open}
         aria-labelledby="students-import-dialog-title">
        <a class="modal-overlay" href="#close" role="button" aria-label="Tutup dialog impor" onclick={closeImportModal}></a>
        <div class="modal-container">
            <div class="modal-header">
                <button class="btn btn-clear float-right" aria-label="Tutup" disabled={state.importModal.applying} onclick={closeImportModal}></button>
                <div class="modal-title h5" id="students-import-dialog-title">Impor Data Siswa</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <p>Unggah file Excel (<code>.xlsx</code>) atau CSV (<code>.csv</code>) untuk menambahkan atau memperbarui data siswa beserta penempatan kelasnya.</p>
                    <div class="import-step mb-2">
                        <label class="form-label"><strong>Langkah 1: Unduh Template</strong></label>
                        <a class="btn btn-sm" href="/api/v1/setup/students/template" target="_blank" download>Unduh Template Excel</a>
                    </div>
                    <div class="import-step mb-2">
                        <label class="form-label" for="students-import-file"><strong>Langkah 2: Pilih File Siswa</strong></label>
                        <input id="students-import-file"
                               class="form-input"
                               type="file"
                               accept=".xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                               disabled={state.importModal.loading || state.importModal.applying}
                               onchange={handleImportFileChange}>
                    </div>
                    <div if={state.importModal.loading} class="loading loading-lg my-2" aria-label="Membaca dan memvalidasi file"></div>
                    <div if={state.importModal.message} class="toast toast-{state.importModal.success ? 'success' : 'error'} my-2">
                        {state.importModal.message}
                    </div>
                    <div if={state.importModal.preview} class="import-preview-section">
                        <div class="toast toast-{state.importModal.preview.valid ? 'success' : 'error'} my-2">
                            {state.importModal.preview.valid ? 'Data valid dan siap diterapkan.' : 'Perbaiki kesalahan sebelum menerapkan data.'}
                            Buat: {state.importModal.preview.summary.create}, ubah: {state.importModal.preview.summary.update}, tetap: {state.importModal.preview.summary.unchanged}.
                        </div>
                        <div class="table-scroll" tabindex="0" role="region" aria-label="Pratinjau impor siswa">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Baris</th>
                                        <th>ID Siswa</th>
                                        <th>Nama</th>
                                        <th>Tahun Ajaran</th>
                                        <th>Kelas</th>
                                        <th>Aksi</th>
                                        <th>Keterangan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr each={item in state.importModal.preview.items}>
                                        <td>{item.index + 1}</td>
                                        <td><code>{item.key}</code></td>
                                        <td>{getPreviewStudentName(item.index)}</td>
                                        <td>{getPreviewStudentYear(item.index)}</td>
                                        <td>{getPreviewStudentClass(item.index)}</td>
                                        <td><span class="label label-{actionClass(item.action)}">{actionLabel(item.action)}</span></td>
                                        <td>{(item.errors || []).join('; ')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn" disabled={state.importModal.applying} onclick={closeImportModal}>Batal</button>
                <button id="students-import-confirm"
                        class="btn btn-success loading-{state.importModal.applying}"
                        disabled={state.importModal.applying || state.importModal.loading || !state.importModal.preview || !state.importModal.preview.valid}
                        onclick={applyImport}>Terapkan Data</button>
            </div>
        </div>
    </div>

    <div class="container students-page">
        <h2>Manajemen Siswa</h2>
        <p class="text-gray">Cari siswa berdasarkan nama atau ID dan lihat penempatan kelas aktif.</p>

        <div if={state.message} class="toast toast-{state.success ? 'success' : 'error'}">
            <button class="btn btn-clear float-right" onclick={clearMessage}></button>
            {state.message}
        </div>

        <section if={canManage()} class="student-create-section">
            <div class="section-title">
                <h4>Tambah Siswa</h4>
                <div class="section-actions">
                    <a class="btn btn-sm" href="/api/v1/setup/students/template" target="_blank" download>Unduh Template</a>
                    <button class="btn btn-sm btn-primary" onclick={openImportModal}>Impor Siswa</button>
                </div>
            </div>
            <div if={isAdmin()} class="student-create-grid">
                <input class="form-input" aria-label="Nama siswa baru" placeholder="Nama lengkap" value={state.newStudent.name} oninput={event => editNewStudent('name', event)}>
                <input class="form-input" aria-label="ID alternatif siswa baru" placeholder="ID alternatif (opsional)" value={state.newStudent.alternativeID} oninput={event => editNewStudent('alternativeID', event)}>
                <select class="form-select" aria-label="Tahun akademik siswa baru" value={state.newStudent.academicYearID} onchange={event => editNewStudent('academicYearID', event)}>
                    <option value="">Pilih tahun akademik</option>
                    <option each={year in state.years} value={year.ID}>{year.label}</option>
                </select>
                <select class="form-select" aria-label="Kelas siswa baru" value={state.newStudent.classLabel} onchange={event => editNewStudent('classLabel', event)}>
                    <option value="">Pilih kelas</option>
                    <option each={item in state.classes} value={item.label}>{item.label}</option>
                </select>
                <button class="btn btn-primary loading-{state.creating}" disabled={state.creating} onclick={createStudent}>Tambah Siswa</button>
            </div>
            <small if={isAdmin()} class="text-gray">ID alternatif akan dibuat otomatis jika dikosongkan dan tidak dapat diubah setelah siswa dibuat.</small>
        </section>

        <section>
            <h4>Daftar Siswa</h4>
            <div class="student-filters">
                <input class="form-input" aria-label="Cari siswa" placeholder="Cari nama atau ID" value={state.filters.query} oninput={editQuery} onkeydown={onSearchKeydown}>
                <select class="form-select" aria-label="Filter tahun akademik" value={state.filters.academicYearID} onchange={event => applyFilter('academicYearID', event)}>
                    <option value="">Semua tahun akademik</option>
                    <option each={year in state.years} value={year.ID}>{year.label}</option>
                </select>
                <select class="form-select" aria-label="Filter kelas" value={state.filters.classLabel} onchange={event => applyFilter('classLabel', event)}>
                    <option value="">Semua kelas</option>
                    <option each={item in state.classes} value={item.label}>{item.label}</option>
                </select>
                <select class="form-select" aria-label="Filter status siswa" value={state.filters.status} onchange={event => applyFilter('status', event)}>
                    <option value="active">Aktif</option>
                    <option value="inactive">Nonaktif</option>
                    <option value="">Semua status</option>
                </select>
                <button class="btn btn-primary" onclick={search}>Cari</button>
                <button class="btn" onclick={resetFilters}>Reset</button>
            </div>

            <div if={canTransfer()} class="transfer-bar">
                <span>{state.selectedIDs.length} siswa dipilih</span>
                <button class="btn btn-sm btn-primary" onclick={openTransferDialog}>Pindahkan</button>
                <button class="btn btn-sm" onclick={clearSelection}>Batal pilih</button>
            </div>

            <div if={state.loading} class="loading loading-lg student-loading" aria-label="Memuat siswa"></div>
            <div if={!state.loading && state.students.length === 0} class="empty">
                <div class="empty-icon"><i class="icon icon-people icon-4x"></i></div>
                <p class="empty-title h5">Tidak ada siswa ditemukan</p>
                <p class="empty-subtitle">Ubah pencarian atau filter untuk melihat siswa lain.</p>
            </div>
            <div if={!state.loading && state.students.length > 0} class="table-scroll" tabindex="0" role="region" aria-label="Daftar siswa">
                <table class="table table-striped">
                    <thead><tr><th class="checkbox-col"><input type="checkbox" aria-label="Pilih semua" checked={allSelected()} onchange={toggleSelectAll}></th><th>ID Siswa</th><th>Nama</th><th>Status</th><th>Penempatan Aktif</th><th if={isAdmin()}>Aksi</th></tr></thead>
                    <tbody>
                        <tr each={item in state.students} class={item.active ? '' : 'student-inactive-row'}>
                            <td class="checkbox-col"><input type="checkbox" aria-label="Pilih {item.name}" checked={isSelected(item)} onchange={() => toggleSelect(item)}></td>
                            <td><code>{item.alternativeID}</code></td>
                            <td>
                                <input if={state.editingID === item.id} class="form-input input-sm" aria-label="Edit nama siswa" value={state.editingName} oninput={event => update({editingName: event.target.value})} onkeydown={event => onEditKeydown(item, event)}>
                                <strong if={state.editingID !== item.id}>{item.name}</strong>
                            </td>
                            <td>
                                <span class="label {item.active ? 'label-success' : 'label-secondary'}">{item.active ? 'Aktif' : 'Nonaktif'}</span>
                            </td>
                            <td>
                                <span if={!item.assignments || item.assignments.length === 0} class="text-gray">Belum ada penempatan aktif</span>
                                <span each={assignment in item.assignments} class="chip assignment-chip {assignment.active ? '' : 'chip-inactive'}">
                                    {assignment.academicYearLabel} · {assignment.classLabel}
                                    <span if={!assignment.active} class="chip-reason" title={assignment.deactivateReason}>(Nonaktif)</span>
                                    <button if={isAdmin() && assignment.active} class="btn btn-clear btn-xs" aria-label="Nonaktifkan penempatan" onclick={() => openPlacementDialog(assignment, item, false)}></button>
                                    <button if={isAdmin() && !assignment.active} class="btn btn-xs btn-placement-restore" aria-label="Aktifkan penempatan" onclick={() => openPlacementDialog(assignment, item, true)}>Aktifkan</button>
                                </span>
                            </td>
                            <td if={isAdmin()}>
                                <div if={state.editingID !== item.id} class="action-buttons">
                                    <button class="btn btn-sm" onclick={() => startEdit(item)}>Ubah Nama</button>
                                    <button if={item.active} class="btn btn-sm btn-error" onclick={() => openStudentDialog(item, false)}>Nonaktifkan</button>
                                    <button if={!item.active} class="btn btn-sm btn-success" onclick={() => openStudentDialog(item, true)}>Aktifkan</button>
                                </div>
                                <div if={state.editingID === item.id} class="action-buttons">
                                    <button class="btn btn-sm btn-success loading-{state.saving}" disabled={state.saving} onclick={() => saveName(item)}>Simpan</button>
                                    <button class="btn btn-sm" disabled={state.saving} onclick={cancelEdit}>Batal</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div if={!state.loading && state.total > 0} class="student-pagination">
                <span>Menampilkan {pageStart()}–{pageEnd()} dari {state.total} siswa</span>
                <div>
                    <button class="btn btn-sm" disabled={state.page <= 1} onclick={() => changePage(state.page - 1)}>Sebelumnya</button>
                    <span>Halaman {state.page} dari {totalPages()}</span>
                    <button class="btn btn-sm" disabled={state.page >= totalPages()} onclick={() => changePage(state.page + 1)}>Berikutnya</button>
                </div>
            </div>
        </section>
    </div>

    <style>
        students section { margin-top: 2rem; }
        students .section-title { align-items: center; display: flex; flex-wrap: wrap; gap: .6rem; justify-content: space-between; margin-bottom: .6rem; }
        students .section-title h4 { margin: 0; }
        students .section-actions { display: flex; flex-wrap: wrap; gap: .4rem; }
        students .modal.modal-lg .modal-container { max-width: min(52rem, calc(100vw - 1.5rem)); }
        students .import-preview-section { margin-top: 1rem; }
        students .import-preview-section table { min-width: 600px; }
        students .student-create-grid, students .student-filters { display: grid; gap: .6rem; grid-template-columns: repeat(auto-fit, minmax(min(100%, 11rem), 1fr)); }
        students .student-create-section small { display: block; margin-top: .5rem; }
        students .table-scroll { overflow-x: auto; }
        students table { min-width: 860px; }
        students .checkbox-col { width: 2.5rem; text-align: center; }
        students .transfer-bar { align-items: center; display: flex; gap: .5rem; margin: .75rem 0; padding: .5rem .75rem; background: #f0f4ff; border-radius: .25rem; }
        students .assignment-chip { height: auto; margin: .1rem .25rem .1rem 0; white-space: normal; display: inline-flex; align-items: center; gap: .25rem; }
        students .chip-inactive { background: #f1f1f1; color: #888; }
        students .chip-reason { font-size: .75rem; color: #888; }
        students .btn-placement-restore { background: transparent; color: #2b7a3d; font-size: .7rem; padding: 0 .25rem; }
        students .student-inactive-row td { opacity: .7; }
        students .action-buttons { display: flex; flex-wrap: wrap; gap: .35rem; }
        students .student-loading { margin: 2rem auto; }
        students .student-pagination { align-items: center; display: flex; flex-wrap: wrap; gap: .7rem; justify-content: space-between; margin-top: 1rem; }
        students .student-pagination > div { align-items: center; display: flex; flex-wrap: wrap; gap: .5rem; }
        @media (max-width: 600px) {
            students .student-create-grid, students .student-filters { grid-template-columns: 1fr; }
            students .student-create-grid .btn, students .student-filters .btn { width: 100%; }
        }
    </style>

    <script>
        const blankStudent = () => ({name: '', alternativeID: '', academicYearID: '', classLabel: ''})
        const blankDialog = () => ({open: false, kind: '', studentID: '', studentName: '', studentClassID: '', reason: '', nextActive: false, saving: false, needsReason: false, destYear: '', destClass: ''})
        const blankImportModal = (overrides = {}) => ({
            open: false,
            students: [],
            preview: null,
            loading: false,
            applying: false,
            message: '',
            success: false,
            ...overrides,
        })
        export default {
            state: {
                role: '', students: [], years: [], classes: [], filters: {query: '', academicYearID: '', classLabel: '', status: 'active'},
                page: 1, pageSize: 50, total: 0, loading: true, creating: false, saving: false,
                newStudent: blankStudent(), editingID: '', editingName: '', message: '', success: false,
                dialog: blankDialog(), importModal: blankImportModal(), selectedIDs: [],
            },
            onMounted() {
                this.dialogKeydownHandler = event => this.closeDialogOnEscape(event)
                window.addEventListener('keydown', this.dialogKeydownHandler)
                Promise.all([axios.get('/api/v1/teacher/session/validate'), axios.get('/api/v1/academic-years'), axios.get('/api/v1/classes')])
                    .then(([profile, years, classes]) => {
                        this.update({role: profile.data.role, years: years.data.items || [], classes: classes.data.items || []})
                        this.loadStudents(1)
                    }).catch(error => { this.fail(error, 'Data siswa tidak dapat dimuat'); this.update({loading: false}) })
            },
            onBeforeUnmount() {
                window.removeEventListener('keydown', this.dialogKeydownHandler)
            },
            isAdmin() { return this.state.role === 'school_admin' },
            canManage() { return this.state.role === 'school_admin' || this.state.role === 'teacher' },
            editNewStudent(field, event) { this.state.newStudent[field] = event.target.value; this.update() },
            createStudent(event) {
                event.preventDefault()
                if (this.state.creating) return
                const student = this.state.newStudent
                if (!student.name.trim() || !student.academicYearID || !student.classLabel) {
                    this.update({message: 'Nama, tahun akademik, dan kelas wajib diisi', success: false})
                    return
                }
                this.update({creating: true, message: ''})
                axios.post('/api/v1/students', student).then(() => {
                    this.update({newStudent: blankStudent(), message: 'Siswa berhasil ditambahkan', success: true})
                    this.loadStudents(1)
                }).catch(error => this.fail(error, 'Siswa tidak berhasil ditambahkan')).finally(() => this.update({creating: false}))
            },
            editQuery(event) { this.state.filters.query = event.target.value; this.update() },
            onSearchKeydown(event) { if (event.key === 'Enter') this.search(event) },
            applyFilter(field, event) { this.state.filters[field] = event.target.value; this.update(); this.loadStudents(1) },
            search(event) { event.preventDefault(); this.loadStudents(1) },
            resetFilters(event) {
                event.preventDefault()
                this.update({filters: {query: '', academicYearID: '', classLabel: '', status: 'active'}, selectedIDs: []})
                this.loadStudents(1)
            },
            loadStudents(page) {
                this.update({loading: true, editingID: '', page})
                axios.get('/api/v1/students', {params: {...this.state.filters, page, pageSize: this.state.pageSize}})
                    .then(response => this.update({students: response.data.items || [], page: response.data.page, total: response.data.total || 0}))
                    .catch(error => this.fail(error, 'Daftar siswa tidak dapat dimuat'))
                    .finally(() => this.update({loading: false}))
            },
            startEdit(item) { this.update({editingID: item.id, editingName: item.name, message: ''}) },
            cancelEdit(event) { if (event) event.preventDefault(); this.update({editingID: '', editingName: ''}) },
            onEditKeydown(item, event) {
                if (event.key === 'Enter') this.saveName(item)
                if (event.key === 'Escape') this.cancelEdit(event)
            },
            saveName(item, event) {
                if (event) event.preventDefault()
                const name = this.state.editingName.trim()
                if (!name) { this.update({message: 'Nama siswa wajib diisi', success: false}); return }
                this.update({saving: true, message: ''})
                axios.patch(`/api/v1/admin/students/${item.id}`, {name}).then(() => {
                    this.update({editingID: '', editingName: '', message: 'Nama siswa berhasil diperbarui', success: true})
                    this.loadStudents(this.state.page)
                }).catch(error => this.fail(error, 'Nama siswa tidak berhasil diperbarui')).finally(() => this.update({saving: false}))
            },
            changePage(page, event) { if (event) event.preventDefault(); this.loadStudents(page) },
            totalPages() { return Math.max(1, Math.ceil(this.state.total / this.state.pageSize)) },
            pageStart() { return (this.state.page - 1) * this.state.pageSize + 1 },
            pageEnd() { return Math.min(this.state.total, this.state.page * this.state.pageSize) },
            clearMessage() { this.update({message: ''}) },
            fail(error, fallback) {
                const message = error.response && error.response.data && error.response.data.message
                this.update({message: message || fallback, success: false})
            },
            getStudentClassIDForTransfer(item) {
                const f = this.state.filters
                if (!f.academicYearID || !f.classLabel) return null
                const assignments = item.assignments || []
                for (const a of assignments) {
                    if (a.academicYearID === f.academicYearID && a.classLabel === f.classLabel && a.active) return a.studentClassID
                }
                return null
            },
            isSelected(item) {
                return this.getStudentClassIDForTransfer(item) !== null && this.state.selectedIDs.indexOf(this.getStudentClassIDForTransfer(item)) >= 0
            },
            selectableStudents() {
                return this.state.students.filter(item => this.getStudentClassIDForTransfer(item) !== null)
            },
            allSelected() {
                const selectable = this.selectableStudents()
                return selectable.length > 0 && selectable.every(item => this.state.selectedIDs.indexOf(this.getStudentClassIDForTransfer(item)) >= 0)
            },
            toggleSelect(item) {
                const id = this.getStudentClassIDForTransfer(item)
                if (!id) return
                const ids = this.state.selectedIDs.slice()
                const idx = ids.indexOf(id)
                if (idx >= 0) ids.splice(idx, 1)
                else ids.push(id)
                this.update({selectedIDs: ids})
            },
            toggleSelectAll() {
                const selectable = this.selectableStudents()
                if (this.allSelected()) {
                    const removeIDs = selectable.map(item => this.getStudentClassIDForTransfer(item))
                    this.update({selectedIDs: this.state.selectedIDs.filter(id => removeIDs.indexOf(id) < 0)})
                } else {
                    const addIDs = selectable.map(item => this.getStudentClassIDForTransfer(item))
                    const merged = this.state.selectedIDs.slice()
                    for (const id of addIDs) { if (merged.indexOf(id) < 0) merged.push(id) }
                    this.update({selectedIDs: merged})
                }
            },
            clearSelection() { this.update({selectedIDs: []}) },
            canTransfer() {
                return this.state.selectedIDs.length > 0 && this.state.filters.academicYearID !== '' && this.state.filters.classLabel !== ''
            },
            sourceYearLabel() {
                const year = this.state.years.find(y => y.ID === this.state.filters.academicYearID)
                return year ? year.label : ''
            },
            openTransferDialog(event) {
                this.dialogTrigger = event && event.currentTarget
                this.update({
                    message: '',
                    dialog: {open: true, kind: 'transfer', studentID: '', studentName: '', studentClassID: '', reason: '', nextActive: false, saving: false, needsReason: false, destYear: '', destClass: ''},
                })
                window.requestAnimationFrame(() => {
                    const confirm = document.getElementById('students-dialog-confirm')
                    if (confirm) confirm.focus()
                })
            },
            openStudentDialog(item, nextActive) {
                this.dialogTrigger = event && event.currentTarget
                this.update({
                    message: '',
                    dialog: {open: true, kind: 'student', studentID: item.id, studentName: item.name, studentClassID: '', reason: '', nextActive, saving: false, needsReason: !nextActive, destYear: '', destClass: ''},
                })
                window.requestAnimationFrame(() => {
                    const confirm = document.getElementById('students-dialog-confirm')
                    if (confirm) confirm.focus()
                })
            },
            openPlacementDialog(assignment, item, nextActive) {
                this.dialogTrigger = event && event.currentTarget
                this.update({
                    message: '',
                    dialog: {open: true, kind: 'placement', studentID: item.id, studentName: item.name, studentClassID: assignment.studentClassID, reason: '', nextActive, saving: false, needsReason: !nextActive, destYear: '', destClass: ''},
                })
                window.requestAnimationFrame(() => {
                    const confirm = document.getElementById('students-dialog-confirm')
                    if (confirm) confirm.focus()
                })
            },
            closeDialog(event) {
                if (event) event.preventDefault()
                if (this.state.dialog.saving) return
                this.update({dialog: blankDialog()})
                if (this.dialogTrigger) {
                    this.dialogTrigger.focus()
                    this.dialogTrigger = null
                }
            },
            closeDialogOnEscape(event) {
                if (event.key === 'Escape') {
                    if (this.state.dialog.open) {
                        this.closeDialog(event)
                    } else if (this.state.importModal.open && !this.state.importModal.applying) {
                        this.closeImportModal(event)
                    }
                }
            },
            dialogTitle() {
                const d = this.state.dialog
                if (d.kind === 'student') return d.nextActive ? 'Aktifkan Siswa' : 'Nonaktifkan Siswa'
                if (d.kind === 'placement') return d.nextActive ? 'Aktifkan Penempatan' : 'Nonaktifkan Penempatan'
                if (d.kind === 'transfer') return 'Pindahkan Siswa'
                return ''
            },
            dialogDescription() {
                const d = this.state.dialog
                if (d.kind === 'student') return d.nextActive ? `Aktifkan kembali siswa "${d.studentName}"?` : `Nonaktifkan siswa "${d.studentName}"? Alasan wajib diisi.`
                if (d.kind === 'placement') return d.nextActive ? 'Aktifkan kembali penempatan ini?' : 'Nonaktifkan penempatan ini? Alasan wajib diisi.'
                if (d.kind === 'transfer') return `Pindahkan ${this.state.selectedIDs.length} siswa ke tahun ajaran dan kelas tujuan?`
                return ''
            },
            dialogConfirmClass() {
                const d = this.state.dialog
                if (d.kind === 'transfer') return 'btn-primary'
                if (d.nextActive) return 'btn-success'
                return 'btn-error'
            },
            dialogConfirmLabel() {
                if (this.state.dialog.kind === 'transfer') return 'Pindahkan'
                return this.state.dialog.nextActive ? 'Aktifkan' : 'Nonaktifkan'
            },
            dialogConfirmEnabled() {
                const d = this.state.dialog
                if (d.kind === 'transfer') return d.destYear !== '' && d.destClass !== ''
                if (!d.needsReason) return true
                return d.reason.trim().length > 0
            },
            confirmDialog(event) {
                event.preventDefault()
                const d = this.state.dialog
                if (d.saving) return
                if (d.kind === 'transfer' && (!d.destYear || !d.destClass)) return
                if (d.needsReason && !d.reason.trim()) return
                this.update({dialog: {...d, saving: true}, message: ''})
                let request
                if (d.kind === 'student') {
                    request = axios.patch(`/api/v1/admin/students/${d.studentID}/status`, {active: d.nextActive, reason: d.reason.trim()})
                } else if (d.kind === 'placement') {
                    request = d.nextActive
                        ? axios.patch(`/api/v1/student/class/${d.studentClassID}/restore`)
                        : axios.patch(`/api/v1/student/class/${d.studentClassID}/deactivate`, {reason: d.reason.trim()})
                } else if (d.kind === 'transfer') {
                    request = axios.post('/api/v1/student/transfer', {
                        studentClassIDs: this.state.selectedIDs,
                        destinationAcademicYearId: d.destYear,
                        destinationClassLabel: d.destClass,
                    })
                }
                if (!request) return
                request.then(response => {
                    let successMessage
                    if (d.kind === 'student') {
                        successMessage = d.nextActive ? 'Siswa berhasil diaktifkan' : 'Siswa berhasil dinonaktifkan'
                    } else if (d.kind === 'placement') {
                        successMessage = d.nextActive ? 'Penempatan berhasil diaktifkan' : 'Penempatan berhasil dinonaktifkan'
                    } else if (d.kind === 'transfer') {
                        const count = response.data && response.data.transferred || this.state.selectedIDs.length
                        successMessage = `${count} siswa berhasil dipindahkan`
                    }
                    this.update({dialog: blankDialog(), selectedIDs: [], message: successMessage, success: true})
                    this.loadStudents(this.state.page)
                }).catch(error => {
                    this.update({dialog: {...d, saving: false}})
                    this.fail(error, d.kind === 'transfer' ? 'Siswa tidak berhasil dipindahkan' : 'Status tidak berhasil diubah')
                })
            },
            openImportModal(event) {
                if (event) event.preventDefault()
                this.update({importModal: blankImportModal({open: true})})
                const fileInput = document.getElementById('students-import-file')
                if (fileInput) fileInput.value = ''
            },
            closeImportModal(event) {
                if (event) event.preventDefault()
                if (this.state.importModal.applying) return
                const fileInput = document.getElementById('students-import-file')
                if (fileInput) fileInput.value = ''
                this.update({importModal: blankImportModal()})
            },
            handleImportFileChange(event) {
                const file = event.target.files[0]
                if (!file) return

                const formData = new FormData()
                formData.append('file', file)

                this.update({
                    importModal: {
                        ...this.state.importModal,
                        loading: true,
                        message: '',
                        preview: null,
                        students: [],
                    },
                })

                axios.post('/api/v1/setup/students/import', formData, {
                    headers: {'Content-Type': 'multipart/form-data'},
                }).then(importRes => {
                    const items = importRes.data.items || []
                    if (items.length === 0) {
                        this.update({
                            importModal: {
                                ...this.state.importModal,
                                loading: false,
                                message: 'File tidak berisi data siswa',
                                success: false,
                            },
                        })
                        return
                    }
                    return axios.post('/api/v1/setup/preview', {students: items}).then(previewRes => {
                        this.update({
                            importModal: {
                                ...this.state.importModal,
                                loading: false,
                                students: items,
                                preview: previewRes.data,
                                message: `${items.length} baris siswa berhasil dibaca dari file`,
                                success: true,
                            },
                        })
                    })
                }).catch(error => {
                    const errMsg = (error.response && error.response.data && error.response.data.message) || 'Gagal membaca atau memvalidasi file siswa'
                    this.update({
                        importModal: {
                            ...this.state.importModal,
                            loading: false,
                            message: errMsg,
                            success: false,
                        },
                    })
                })
            },
            applyImport(event) {
                if (event) event.preventDefault()
                const modal = this.state.importModal
                if (modal.applying || !modal.preview || !modal.preview.valid || modal.students.length === 0) return

                this.update({
                    importModal: {
                        ...modal,
                        applying: true,
                        message: '',
                    },
                })

                axios.post('/api/v1/setup/apply', {students: modal.students}).then(() => {
                    const count = modal.students.length
                    const fileInput = document.getElementById('students-import-file')
                    if (fileInput) fileInput.value = ''
                    this.update({
                        importModal: blankImportModal(),
                        message: `${count} siswa berhasil diimpor`,
                        success: true,
                    })
                    this.loadStudents(1)
                }).catch(error => {
                    const errMsg = (error.response && error.response.data && error.response.data.message) || 'Gagal menerapkan data impor siswa'
                    this.update({
                        importModal: {
                            ...this.state.importModal,
                            applying: false,
                            message: errMsg,
                            success: false,
                        },
                    })
                })
            },
            getPreviewStudentName(index) {
                const s = this.state.importModal.students[index]
                return s ? s.name : ''
            },
            getPreviewStudentYear(index) {
                const s = this.state.importModal.students[index]
                return s ? s.academicYearLabel : ''
            },
            getPreviewStudentClass(index) {
                const s = this.state.importModal.students[index]
                return s ? s.classLabel : ''
            },
            actionLabel(action) {
                if (action === 'create') return 'Buat'
                if (action === 'update') return 'Ubah'
                if (action === 'unchanged') return 'Tetap'
                return action || '-'
            },
            actionClass(action) {
                if (action === 'create') return 'success'
                if (action === 'update') return 'warning'
                if (action === 'unchanged') return 'secondary'
                return 'secondary'
            },
        }
    </script>
</students>
